import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActionsComponent } from './actions.component';

const routes: Routes = [{
  path: 'gridActions',
  component: ActionsComponent,
  data: {
    title: 'Actions'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ActionsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/actions/actions-routing.module.ts